import React from 'react';
import PropTypes from 'prop-types';
import './PatientVideoCallPage.css';
import VideoCall from '../../components/telemedicina/VideoCall';
import NotesDisplay from './NotesDisplay';
import PrescriptionDisplay from './PrescriptionDisplay';

const PatientVideoCallPage = ({ token, roomName }) => {
  return (
    <div className="patient-video-call-container">
      <h2 className="video-call-heading">Teleatendimento Médico</h2>
      <div className="video-call-wrapper">
        <VideoCall token={token} roomName={roomName} />
      </div>
      <div className="patient-info-section">
        <NotesDisplay />
        <PrescriptionDisplay />
      </div>
    </div>
  );
};

PatientVideoCallPage.propTypes = {
  token: PropTypes.string.isRequired,
  roomName: PropTypes.string.isRequired,
};

export default PatientVideoCallPage;
